var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarehouse = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7442 1.92527C12.2831 1.66175 11.7169 1.66175 11.2558 1.92527L2.25579 7.06812C1.78843 7.33519 1.5 7.8322 1.5 8.37049V21C1.5 21.8284 2.17157 22.5 3 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V8.37049C22.5 7.8322 22.2116 7.33519 21.7442 7.06812L12.7442 1.92527ZM12.7442 3.42527C12.2831 3.16175 11.7169 3.16175 11.2558 3.42527L3.3779 7.92692C3.14421 8.06045 3 8.30896 3 8.5781V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V8.5781C21 8.30896 20.8558 8.06045 20.6221 7.92692L12.7442 3.42527Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 9C6.67157 9 6 9.67158 6 10.5V21H7.5V11.25C7.5 10.8358 7.83579 10.5 8.25 10.5H15.75C16.1642 10.5 16.5 10.8358 16.5 11.25V21H18V10.5C18 9.67158 17.3284 9 16.5 9H7.5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 14.25C9 13.8358 9.33579 13.5 9.75 13.5H14.25C14.6642 13.5 15 13.8358 15 14.25C15 14.6642 14.6642 15 14.25 15H9.75C9.33579 15 9 14.6642 9 14.25Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 17.25C9 16.8358 9.33579 16.5 9.75 16.5H14.25C14.6642 16.5 15 16.8358 15 17.25C15 17.6642 14.6642 18 14.25 18H9.75C9.33579 18 9 17.6642 9 17.25Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarehouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warehouse.3f3c80d1bc7411f1df7f275ebdf2186a.svg";